import React, { useState, useRef, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { 
    Flex, Box, Heading, FormControl, FormLabel, Input, Button, ButtonGroup, Text, CircularProgress,
    Grid, GridItem, VStack, Spacer, Divider, Icon,
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, ModalFooter, useDisclosure,
    Textarea, Select
} from '@chakra-ui/react';
import { MdSave } from 'react-icons/md';
import { Form, Field } from 'react-final-form';
import validator from "validator";
import { GENDER } from '../../../constants';

function AddEditPatientModal({ 
    company_id, patientDetail, enterprise_id, enterpriseList, actionStatus, initialRef, isOpen, onClose,  
    apiCreateNewPatient, apiUpdateAPatient,
}) {
    const [ cookies ] = useCookies(["loginCookie"]);
    const [ isValidPhone, setIsValidPhone ] = useState(true);
    const [ isValidEmail, setIsValidEmail ] = useState(true);
    const [ isProcessing, setIsProcessing ] = useState(false);

    useEffect(() => {
        if(!actionStatus) {
            setIsProcessing(false);
        }
    }, [actionStatus]);

    const validate = (values) => {
        const errors = {};

        if(!values.name) {
            errors.name = "Required";
        }
        if(!values.yearOfBirth) {
            errors.yearOfBirth = "Required";
        }
        if(!values.gender) {
            errors.gender = "Required";
        }
        if(!values.phone) {
            errors.phone = "Required";
        }
        if(!values.passport) {
            errors.passport = "Required";
        }

        if(values.phone?.length > 0) {
            const isValidPhone = validator.isMobilePhone(values.phone, "vi-VN");
            setIsValidPhone(isValidPhone);
            if(!isValidPhone) {
                errors.validPhone = "Required";
            }
        }

        if(values.email?.length > 0) {
            const isValidEmail = validator.isEmail(values.email);
            setIsValidEmail(isValidEmail);
        }

        return errors;
    }

    const onSubmit = async(values) => {
        setIsProcessing(true);
        if(patientDetail && patientDetail.id) {
            apiUpdateAPatient({ 
                id: patientDetail.id, 
                payload: { 
                    ...values,
                    user_id: cookies?.loginCookie?.data?.id,   
                }
            });
        } else {
            apiCreateNewPatient({ 
                ...values,
                user_id: cookies?.loginCookie?.data?.id,   
            });
        }
    }

    return (
        <Modal initialFocusRef={initialRef} isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false} size="xl">
            <ModalOverlay />
            <Form
                onSubmit={onSubmit}
                initialValues={{
                    company_id,
                    ...patientDetail,
                    enterprise_id: patientDetail?.enterprise_id || enterprise_id
                }}
                validate={validate}
                render={({ handleSubmit, form, submitting, pristine, valid, values }) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <ModalContent>
                                <ModalHeader>
                                    { patientDetail && patientDetail.id ? "CẬP NHẬT" : "TẠO MỚI" }
                                </ModalHeader>
                                <ModalCloseButton />

                                <ModalBody pb={6}>
                                    <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} mx={2} my={2} justify="space-between" gap={2}>
                                        <VStack justify="flex-start" width="100%">
                                            <Field name="name">
                                                {({ input, meta }) => (
                                                    <FormControl isRequired>
                                                        <FormLabel fontWeight="700">Họ tên:</FormLabel>
                                                        <Input {...input} type='text' placeholder=''/>
                                                    </FormControl>
                                                )}
                                            </Field>

                                            <Field name="gender">
                                                {({ input, meta }) => (
                                                    <FormControl isRequired>
                                                        <FormLabel fontWeight="700">Giới tính:</FormLabel>
                                                        <Select {...input} placeholder='Chọn giới tính'>
                                                            {
                                                                Object.keys(GENDER).map(key => (
                                                                    <React.Fragment key={key}>
                                                                        <option value={key}>{GENDER[key]}</option>
                                                                    </React.Fragment>
                                                                ))
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                )}
                                            </Field>

                                            <Field name="passport">
                                                {({ input, meta }) => (
                                                    <FormControl isRequired>
                                                        <FormLabel fontWeight="700">Căn cước công dân:</FormLabel>
                                                        <Input {...input} type='text' placeholder=''/>
                                                    </FormControl>
                                                )}
                                            </Field>

                                            <Field name="phone">
                                                {({ input, meta }) => (
                                                    <FormControl isRequired>
                                                        <FormLabel fontWeight="700">Số điện thoại:</FormLabel>
                                                        <Input {...input} type="text"/>
                                                        {
                                                            !isValidPhone &&
                                                            <FormLabel color="red">Nhập đúng Số Điện Thoại</FormLabel>
                                                        }
                                                    </FormControl>
                                                )}
                                            </Field>
                                        </VStack>

                                        <VStack justify="flex-start" width="100%">
                                            <Field name="yearOfBirth">
                                                {({ input, meta }) => (
                                                    <FormControl isRequired>
                                                        <FormLabel fontWeight="700">Năm sinh:</FormLabel>
                                                        <Input {...input} type="number" />
                                                    </FormControl>
                                                )}
                                            </Field>

                                            <Field name="social_insurance">
                                                {({ input, meta }) => (
                                                    <FormControl>
                                                        <FormLabel fontWeight="700">Số thẻ BHYT:</FormLabel>
                                                        <Input {...input} type='text' placeholder=''/>
                                                    </FormControl>
                                                )}
                                            </Field>

                                            <Field name="issued_by">
                                                {({ input, meta }) => (
                                                    <FormControl>
                                                        <FormLabel fontWeight="700">Nơi cấp:</FormLabel>
                                                        <Input {...input} type='text' placeholder=''/>
                                                    </FormControl>
                                                )}
                                            </Field>

                                            <Field name="email">
                                                {({ input, meta }) => (
                                                    <FormControl>
                                                        <FormLabel fontWeight="700">Email:</FormLabel>
                                                        <Input {...input} type="email"/>
                                                        {
                                                            !isValidEmail &&
                                                            <FormLabel color="red">Nhập đúng Email</FormLabel>
                                                        }
                                                    </FormControl>
                                                )}
                                            </Field>
                                        </VStack>
                                    </Flex>

                                    <Flex flexDirection="column" m={2} gap={2}>
                                        <Field name="enterprise_id">
                                            {({ input, meta }) => (
                                                <FormControl>
                                                    <FormLabel fontWeight="700">Thuộc Doanh nghiệp:</FormLabel>
                                                    <Select {...input} placeholder='Chọn Doanh nghiệp'>
                                                        {
                                                            enterpriseList && enterpriseList.map(item => (
                                                                <React.Fragment key={item.id}>
                                                                    <option value={item.id}>{item.name}</option>
                                                                </React.Fragment>
                                                            ))
                                                        }
                                                    </Select>
                                                </FormControl>
                                            )}
                                        </Field>

                                        <Field name="address">
                                            {({ input, meta }) => (
                                                <FormControl>
                                                    <FormLabel fontWeight="700">Địa chỉ:</FormLabel>
                                                    <Input {...input} type='text' placeholder=''/>
                                                </FormControl>
                                            )}
                                        </Field>
                                    </Flex>
                                </ModalBody>

                                <ModalFooter>
                                    <Button colorScheme='blue' mr={3} type='submit' isDisabled={!valid | pristine}
                                        isLoading={isProcessing}
                                        loadingText="Đang lưu"
                                    >
                                        <Icon boxSize={6} as={MdSave} marginRight="8px"/> 
                                        <Text fontSize="14px">Lưu</Text>
                                    </Button>
                                </ModalFooter>
                            </ModalContent>
                        </form>
                    )
                }}
            />
        </Modal>
    )
}

export default AddEditPatientModal;